var _path, _g, _path2, _g2, _path3, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _g12, _path14, _path15, _g13, _path16, _path17, _g14, _path18, _g15, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRelevanceLogoBluePosRgb = function SvgRelevanceLogoBluePosRgb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 48,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Relevance_Logo_Blue_Pos_RGB_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Relevance_Logo_Blue_Pos_RGB_svg__b",
    width: 4,
    height: 4,
    x: 134,
    y: 12,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M134.848 12.717h2.32v2.324h-2.32z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Relevance_Logo_Blue_Pos_RGB_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M137.169 13.879a1.162 1.162 0 1 1-2.324 0 1.162 1.162 0 0 1 2.324 0",
    opacity: 0.25
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Relevance_Logo_Blue_Pos_RGB_svg__c",
    width: 3,
    height: 4,
    x: 132,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M132.94.067h1.657v3.317h-1.657z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Relevance_Logo_Blue_Pos_RGB_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M134.597 1.725c0 .916-.741 1.66-1.657 1.66V.067c.916 0 1.657.742 1.657 1.658",
    opacity: 0.78
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M139.024 6.843a1.283 1.283 0 1 1-2.566 0 1.283 1.283 0 0 1 2.566 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Relevance_Logo_Blue_Pos_RGB_svg__d",
    width: 4,
    height: 4,
    x: 138,
    y: 10,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M138.113 10.278h3.657v3.66h-3.657z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Relevance_Logo_Blue_Pos_RGB_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M141.771 12.108a1.83 1.83 0 1 1-3.66.002 1.83 1.83 0 0 1 3.66-.002",
    opacity: 0.75
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Relevance_Logo_Blue_Pos_RGB_svg__e",
    width: 3,
    height: 4,
    x: 139,
    y: 15,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M139.321 15.463h2.595v2.597h-2.595z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Relevance_Logo_Blue_Pos_RGB_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M141.916 16.762a1.298 1.298 0 1 1-2.596.001 1.298 1.298 0 0 1 2.596-.001",
    opacity: 0.51
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Relevance_Logo_Blue_Pos_RGB_svg__f",
    width: 8,
    height: 7,
    x: 140,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M140.895 1.56h6.275V7.84h-6.275z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Relevance_Logo_Blue_Pos_RGB_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M147.17 4.7a3.14 3.14 0 0 1-3.138 3.141 3.14 3.14 0 0 1-3.138-3.14 3.14 3.14 0 0 1 3.138-3.141 3.14 3.14 0 0 1 3.138 3.14",
    opacity: 0.66
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Relevance_Logo_Blue_Pos_RGB_svg__g",
    width: 6,
    height: 6,
    x: 143,
    y: 9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M143.106 9.004h5.057v5.062h-5.057z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Relevance_Logo_Blue_Pos_RGB_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M148.163 11.535a2.53 2.53 0 1 1-5.057 0 2.53 2.53 0 1 1 5.057 0",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Relevance_Logo_Blue_Pos_RGB_svg__h",
    width: 4,
    height: 4,
    x: 150,
    y: 11,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M150.495 11.17h3.314v3.318h-3.314z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Relevance_Logo_Blue_Pos_RGB_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M153.81 12.829a1.658 1.658 0 1 1-3.316.001 1.658 1.658 0 0 1 3.316-.001",
    opacity: 0.52
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Relevance_Logo_Blue_Pos_RGB_svg__i",
    width: 3,
    height: 3,
    x: 149,
    y: 18,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M149.169 18.592h1.914v1.916h-1.914z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Relevance_Logo_Blue_Pos_RGB_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M151.083 19.55a.957.957 0 1 1-1.915.001.957.957 0 0 1 1.915-.002",
    opacity: 0.75
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Relevance_Logo_Blue_Pos_RGB_svg__j",
    width: 6,
    height: 5,
    x: 147,
    y: 26,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M147.845 26.569h4.335v4.339h-4.335z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Relevance_Logo_Blue_Pos_RGB_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M152.18 28.738a2.168 2.168 0 1 1-4.335 0 2.168 2.168 0 1 1 4.335 0",
    opacity: 0.32
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Relevance_Logo_Blue_Pos_RGB_svg__k",
    width: 4,
    height: 3,
    x: 138,
    y: 30,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M138.816 30.33h2.573v2.576h-2.573z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Relevance_Logo_Blue_Pos_RGB_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M141.389 31.618a1.287 1.287 0 1 1-2.574.001 1.287 1.287 0 0 1 2.574 0",
    opacity: 0.86
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Relevance_Logo_Blue_Pos_RGB_svg__l",
    width: 7,
    height: 8,
    x: 149,
    y: 31,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M149.081 31.96h6.143v6.15h-6.143z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Relevance_Logo_Blue_Pos_RGB_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M155.224 35.035a3.073 3.073 0 0 1-3.072 3.075 3.073 3.073 0 0 1-3.071-3.075 3.073 3.073 0 0 1 3.071-3.074 3.073 3.073 0 0 1 3.072 3.074",
    opacity: 0.39
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Relevance_Logo_Blue_Pos_RGB_svg__m",
    width: 5,
    height: 5,
    x: 143,
    y: 34,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M143.373 34.686h3.902v3.905h-3.902z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Relevance_Logo_Blue_Pos_RGB_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M147.275 36.639a1.951 1.951 0 1 1-3.901 0 1.951 1.951 0 1 1 3.901 0",
    opacity: 0.48
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M140.985 35.914a1.318 1.318 0 1 1-2.635 0 1.318 1.318 0 0 1 2.635 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Relevance_Logo_Blue_Pos_RGB_svg__n",
    width: 3,
    height: 2,
    x: 134,
    y: 33,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M134.53 33.399h1.548v1.55h-1.548z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Relevance_Logo_Blue_Pos_RGB_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M136.078 34.174a.775.775 0 1 1-1.55 0 .775.775 0 0 1 1.55 0",
    opacity: 0.9
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M146.463 43.163a2.432 2.432 0 1 1-4.861 0 2.431 2.431 0 1 1 4.861 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Relevance_Logo_Blue_Pos_RGB_svg__o",
    width: 4,
    height: 4,
    x: 135,
    y: 39,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M135.945 39.76h2.746v2.749h-2.746z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Relevance_Logo_Blue_Pos_RGB_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M138.69 41.135a1.373 1.373 0 1 1-1.372-1.374c.758 0 1.372.615 1.372 1.374",
    opacity: 0.48
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Relevance_Logo_Blue_Pos_RGB_svg__p",
    width: 3,
    height: 4,
    x: 132,
    y: 44,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M132.94 44.28h1.856v3.716h-1.856z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Relevance_Logo_Blue_Pos_RGB_svg__p)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0067FF",
    d: "M134.796 46.138a1.857 1.857 0 0 1-1.856 1.858V44.28c1.025 0 1.856.831 1.856 1.857",
    opacity: 0.48
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M132.94 32.944c-4.901 0-8.889-3.992-8.889-8.898s3.988-8.898 8.889-8.898v-3.636c-6.905 0-12.522 5.622-12.522 12.534s5.617 12.534 12.522 12.534zm12.672-10.56h10.622c-.138-2.044-1.73-4.78-5.155-4.78-3.737 0-5.225 2.84-5.467 4.78m14.221 2.84h-14.256c.069 2.424 1.972 5.16 5.675 5.16 3.079 0 4.705-1.94 5.051-2.46l2.319 1.975c-.623.866-3.08 3.533-7.405 3.533-5.744 0-9.342-4.19-9.342-9.351 0-5.3 3.806-9.421 9.204-9.421 5.259 0 8.788 4.052 8.788 9.317 0 .415 0 .796-.034 1.247m-59.095 7.688V15.18h3.357l.138 2.355h.069c.311-.52 1.799-2.875 5.536-2.875 3.979 0 6.678 2.563 6.678 7.1v11.152h-3.564V22.487c0-3.428-1.834-4.675-3.944-4.675-2.768 0-4.706 2.217-4.706 5.507v9.593zM92.14 24.67v-.243c-5.224.173-8.546.38-8.546 3.394 0 1.94 1.522 2.702 3.218 2.702 3.322 0 5.328-2.251 5.328-5.853m3.46-3.048v11.29h-3.39l-.139-2.32h-.069c-.657 1.074-2.353 2.84-5.744 2.84-3.322 0-6.193-1.87-6.193-5.542 0-1.662.553-2.874 1.487-3.81 1.8-1.8 4.775-2.112 10.588-2.285v-.243c0-2.424-1.626-3.913-4.082-3.913-2.284 0-4.049 1.073-5.26 2.632l-2.18-2.009c.623-.9 2.976-3.602 7.543-3.602 4.43 0 7.44 2.598 7.44 6.962m-28.348 11.29L60.678 15.18h3.771l5.052 14.546h.07l5.017-14.546h3.667l-6.609 17.732zM45.205 22.384h10.622c-.138-2.044-1.73-4.78-5.155-4.78-3.737 0-5.225 2.84-5.467 4.78m14.22 2.84H45.17c.07 2.424 1.972 5.16 5.675 5.16 3.08 0 4.706-1.94 5.052-2.46l2.318 1.975c-.623.866-3.08 3.533-7.405 3.533-5.744 0-9.342-4.19-9.342-9.351 0-5.3 3.806-9.421 9.204-9.421 5.26 0 8.789 4.052 8.789 9.317 0 .415 0 .796-.035 1.247M33.715 7.214h3.564v25.698h-3.564zm-18.373 15.17h10.623c-.138-2.044-1.73-4.78-5.155-4.78-3.737 0-5.225 2.84-5.468 4.78m14.222 2.84H15.307c.07 2.424 1.972 5.16 5.675 5.16 3.079 0 4.705-1.94 5.051-2.46l2.319 1.975c-.623.866-3.08 3.533-7.405 3.533-5.744 0-9.342-4.19-9.342-9.351 0-5.3 3.806-9.421 9.203-9.421 5.26 0 8.79 4.052 8.79 9.317 0 .415 0 .796-.035 1.247M.073 32.912V15.18h3.39l.173 2.77h.07c1.28-2.147 3.771-3.22 5.951-3.22v3.601c-1.66-.069-3.356.208-4.567 1.386-1.384 1.35-1.453 3.29-1.453 5.333v7.862z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Relevance_Logo_Blue_Pos_RGB_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h159.957v48H0z"
  })))));
};
export { SvgRelevanceLogoBluePosRgb as ReactComponent };
export default __webpack_public_path__ + "8ea56ee051fcc2d87d42fb2102aab757.svg";